import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Button } from '@mui/material';
const ButtonTabs = ({ tabs, value, onChange, variant = 'contained-white', size = 'medium', fullWidth = false, sx = {} }) => {
    const isInsideWhite = variant === 'contained-inside-white';
    return (_jsx(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            bgcolor: isInsideWhite ? '#fff' : 'transparent',
            borderRadius: isInsideWhite ? 2 : 0,
            px: isInsideWhite ? 1 : 0,
            ...sx
        }, children: tabs.map((tab) => {
            const isActive = tab.value === value;
            return (_jsx(Button, { variant: isActive ? 'contained' : 'white', color: isActive ? 'primary' : 'inherit', size: size, sx: {}, onClick: () => onChange(tab.value), fullWidth: fullWidth, children: tab.label }, tab.value));
        }) }));
};
export default ButtonTabs;
